module.exports = __webpack_public_path__ + "img/imgCircle.5c0dd383.png";